import Vue from "vue";
//import { fieldValue } from '@firebase/firestore'
import firebase from "firebase";"@firebase/firestore"



function getRef(orgId) {
    return  Vue.prototype.$db
        .collection("organisations")
        .doc(orgId)
        .collection("reports1"); 
}

export async function getBudgetItemsTotalsReport1(orgId) {
  return getRef(orgId)
    .doc("BudgetItemsTotalsReports")
    .get();
}




export async function addReport(orgId, budgetItems) {

   
    return getRef(orgId)
      .doc("BudgetItemsTotalsReports")
      .update({ rows: firebase.firestore.FieldValue.arrayUnion(budgetItems)});
  }
  export async function deleteReport(orgId, budgetItems) {

    return getRef(orgId)
      .doc("BudgetItemsTotalsReports")
      .update({ rows: firebase.firestore.FieldValue.arrayRemove(budgetItems) });
  }